/** Roles com permissão para criar e editar ERs. */
export const MANAGE_ER_ROLES = ['Conselheiro', 'ConselheiroAuxiliar', 'EmbaixadorChefe', 'Secretario'] as const;

/** Roles com permissão para inativar ERs. */
export const DELETE_ER_ROLES = ['Conselheiro', 'ConselheiroAuxiliar', 'EmbaixadorChefe'] as const;

/** Roles com acesso ao módulo de chamadas semanais. */
export const CHAMADA_ROLES = ['Conselheiro', 'ConselheiroAuxiliar', 'EmbaixadorChefe', 'Secretario'] as const;

/** Roles que podem gerenciar postos (marcar requisitos, tarefas, solicitar promoção). */
export const POSTO_MANAGE_ROLES = ['Conselheiro', 'ConselheiroAuxiliar', 'EmbaixadorChefe', 'Secretario'] as const;

/** Roles com permissão para aprovar ou negar promoções de posto. */
export const POSTO_APPROVE_ROLES = ['Conselheiro', 'ConselheiroAuxiliar'] as const;

/** Roles com acesso ao módulo de relatórios. */
export const RELATORIO_ROLES = ['EmbaixadorChefe', 'Conselheiro', 'ConselheiroAuxiliar'] as const;

/** Roles com permissão para criar, editar e excluir eventos. */
export const EVENTO_MANAGE_ROLES = ['Conselheiro', 'ConselheiroAuxiliar', 'EmbaixadorChefe', 'Secretario'] as const;

/** Roles que podem enviar convites para a organização. */
export const INVITE_SEND_ROLES = ['Conselheiro', 'ConselheiroAuxiliar'] as const;

/** Roles que podem gerenciar usuários da organização. */
export const USER_MANAGE_ROLES = ['Conselheiro', 'ConselheiroAuxiliar'] as const;

/** Roles que visualizam frequência pessoal no dashboard (mensal e anual). */
export const FREQUENCIA_ROLES = ['Responsavel', 'EmbaixadorChefe', 'Secretario'] as const;

/** Roles que podem ser convidadas por um Conselheiro. */
export const INVITE_ROLES = [
  { value: 'ConselheiroAuxiliar', label: 'Conselheiro Auxiliar' },
  { value: 'EmbaixadorChefe', label: 'Embaixador Chefe' },
  { value: 'Secretario', label: 'Secretário' },
  { value: 'Responsavel', label: 'Responsável' },
] as const;
